import script from "./BackendPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./BackendPagination.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__